/**
 * Thom Umzug Theme - Main JavaScript
 * Modern ES6+ JavaScript with performance optimization
 * No external dependencies - pure vanilla JavaScript
 */

import { initNavigation } from './modules/navigation.js';
import { initNavbarToggle } from './modules/navbar.js';
import { initCarousel } from './modules/carousel.js';
import { initAnimations } from './modules/animations.js';
import { initMaps } from './modules/map.js';
import { initGallery } from './modules/gallery.js';
import { initParallax } from './modules/parallax.js';
import { initTabs } from './modules/tabs.js';
import { initResponsiveImages } from './modules/responsive-images.js';
import { initCalculator } from './modules/calculator.js';
import { initFormMessages } from './modules/form-messages.js';
import { initTracking } from './modules/tracking.js';

// Import styles
import '../scss/main.scss';
import 'leaflet/dist/leaflet.css';

/**
 * Initialize the application
 */
const init = () => {
    // Check if DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onDOMReady);
    } else {
        onDOMReady();
    }
};

/**
 * Execute when DOM is ready
 */
const onDOMReady = () => {
    console.log('Thom Umzug Theme initialized - No jQuery, No Bootstrap!');

    // Initialize modules
    initNavigation();
    initNavbarToggle();
    initResponsiveImages(); // Initialize before parallax so backgrounds are ready
    initCarousel();
    initAnimations();
    initMaps();
    initGallery();
    initParallax();
    initTabs();
    initCalculator();
    initFormMessages();
    initTracking();

    // Add smooth scroll behavior to anchor links
    initSmoothScroll();
};

/**
 * Initialize smooth scrolling for anchor links
 */
const initSmoothScroll = () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');

            // Skip if it's just "#"
            if (href === '#') return;

            const target = document.querySelector(href);

            if (target) {
                e.preventDefault();

                // Calculate offset for fixed header
                const headerHeight = document.querySelector('#secondaryMenu')?.offsetHeight || 0;
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

                // Update URL without triggering navigation
                if (window.history && window.history.pushState) {
                    window.history.pushState(null, '', href);
                }
            }
        });
    });
};

// Initialize the app
init();
